module.exports = "<div class=\"tooltip error\">\n  <div class=\"tooltip-arrow\"></div>\n  <div class=\"tooltip-inner\"></div>\n</div>\n";